import {
  NOME,
  COGNOME,
  CF,
  EMAIL,
  TELEFONO,
  NOME_OLD_API,
  COGNOME_OLD_API,
  CF_OLD_API,
  EMAIL_OLD_API,
  TELEFONO_OLD_API,
  NOME_API,
  COGNOME_API,
  CF_API,
  EMAIL_API,
  TELEFONO_API,
} from "./index";

export const estraiJwtInfo = (jwtInfo) => {
  var userInfo = null;
  if (jwtInfo)
    userInfo = {
      // Nuovi claims WSO2
      ...(jwtInfo[NOME_API] != null && { [NOME]: jwtInfo[NOME_API] }),
      ...(jwtInfo[COGNOME_API] != null && { [COGNOME]: jwtInfo[COGNOME_API] }),
      ...(jwtInfo[CF_API] != null && { [CF]: jwtInfo[CF_API].replace("TINIT-", "") }),
      ...(jwtInfo[EMAIL_API] != null && { [EMAIL]: jwtInfo[EMAIL_API] }),
      ...(jwtInfo[TELEFONO_API] != null && { [TELEFONO]: jwtInfo[TELEFONO_API] }),
      // Vecchi claims WSO2
      ...(jwtInfo[NOME_OLD_API] != null && { [NOME]: jwtInfo[NOME_OLD_API] }),
      ...(jwtInfo[COGNOME_OLD_API] != null && { [COGNOME]: jwtInfo[COGNOME_OLD_API] }),
      ...(jwtInfo[CF_OLD_API] != null && { [CF]: jwtInfo[CF_OLD_API].replace("TINIT-", "") }),
      ...(jwtInfo[EMAIL_OLD_API] != null && { [EMAIL]: jwtInfo[EMAIL_OLD_API] }),
      ...(jwtInfo[TELEFONO_OLD_API] != null && { [TELEFONO]: jwtInfo[TELEFONO_OLD_API] }),
    };
  return userInfo;
};
